<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('instructor_exam_requests')"
                        :isFilter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('instructor_exam_requests')"
                              :isFilter="false">
                </HeaderMobile>
            </template>
            <b-row>
                <b-col md="3">
                    <b-card bg-variant="light" class="text-center cursor-pointer"
                            @click="getTableData('midterm')">
                        <b-card-text>
                            {{ $t('midterm_exam').toUpper() }}
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col md="3">
                    <b-card bg-variant="light" class="text-center cursor-pointer"
                            @click="getTableData('final')">
                        <b-card-text>
                            {{ $t('final_exam').toUpper() }}
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col cols="12" class="mt-3" v-if="isTableVisible && data.length > 0">
                    <b-table
                        :items="data"
                        :fields="fields"
                        bordered
                        striped
                    >
                        <template #cell(status)="data">
                            <b-form-select v-model="data.item.status" @input="onIsInProgramChange(data.item)" :options="options"></b-form-select>
<!--                            <yes-no-selectbox v-model="data.item.status" @input="onIsInProgramChange(data.item)"/>-->
                        </template>
                        <template #cell(classroom_type)="data">
                            <parameter-selectbox
                                v-if="data.item.status === 'yes' || data.item.classroom_type"
                                code="classroom_types"
                                v-model="data.item.classroom_type"
                                :disabled="data.item.status == null || data.item.status === 'no'"
                            ></parameter-selectbox>
                        </template>
                        <template #cell(explanation)="data">
                            <b-form-input
                                v-model="data.item.explanation"
                                :disabled="
                                    data.item.status == null ||
                                    data.item.status === 'no'
                                "
                                :state="
                                    data.item.explanation_error ? false : null
                                "
                            />
                        </template>
                    </b-table>
                    <div class="d-flex justify-content-end mt-4">
                        <b-button variant="primary"
                                  @click="update"
                                  v-if="this.checkPermission('instructorexamrequest_setinstructorexamrequest')">
                            {{ $t('save') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

import InstructorExamRequestService from "@/services/InstructorExamRequestService";

export default {
    components: {
        ParameterSelectbox,
        AppLayout,
        Header,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t("instructor_exam_requests"),
        };
    },
    data() {
        return {
            data: [],
            isLoading: false,
            fields: [
                {
                    key: 'course_code',
                    label: this.$t('course_code').toUpper(),
                    sortable: false
                },
                {
                    key: 'course_name',
                    label: this.$t('course_name'),
                    sortable: false
                },
                {
                    key: 'section',
                    label: this.$t('section_1').toLocaleUpperCase('en-EN'),
                    sortable: false
                },
                {
                    key: 'status',
                    label: this.$t('is_in_program').toUpper(),
                    sortable: false
                },
                {
                    key: 'classroom_type',
                    label: this.$t('private_classroom').toUpper(),
                    sortable: false
                },
                {
                    key: 'explanation',
                    label: this.$t('explanation').toUpper(),
                    sortable: false
                },
            ],
            isTableVisible: false,
            examType: null,
            options: [
                {
                    text: this.$t('select'), value: 'waiting',
                },
                {
                    text: this.$t('yes'), value: 'yes',
                },
                {
                    text: this.$t('no'), value: 'no',
                },
            ]
        };
    },
    methods: {
        getTableData(examType) {
            this.isLoading = true;
            this.isTableVisible = false;
            this.examType = examType;

            InstructorExamRequestService.getAll(examType)
                .then((response) => {
                    this.data = response.data.data.map(item => ({
                        ...item,
                        status: item.status,
                        explanation_error: null,
                    }));
                    this.isTableVisible = true;
                })
                .catch((error) => {
                    this.$toast.error(this.$t('exam_request_message'));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async update() {
            const result = await this.$swal.fire({
                text: this.$t("are_you_sure_want_save"),
                showCancelButton: true,
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("no"),
                icon: 'question'
            });

            if (!result.isConfirmed) return;

            if (!this.examType) {
                return;
            }

            let unselectedStatusRows = this.data.filter(item => item.status == null);
            if (unselectedStatusRows.length > 0) {
                this.$toast.error(this.$t('status_required_message'));
                return;
            }

            const formData = new FormData();

            this.data.forEach((item, index) => {
                formData.append(`data[${index}][course_code]`, item.course_code);
                formData.append(`data[${index}][status]`, item.status ?? '');
                formData.append(`data[${index}][section]`, item.section ?? '');
                formData.append(`data[${index}][classroom_type]`, item.classroom_type ?? '');
                formData.append(`data[${index}][explanation]`, item.explanation ?? '');
            });

            try {
                await InstructorExamRequestService.update(this.examType, formData);
                this.$toast.success(this.$t('successfully_saved'));
                 this.data.forEach((item) => {
                    item.explanation_error = null;
                });
            } catch (e) {
                let message = this.$t("api." + e.data.message);

                if (typeof e.data.errors !== "undefined") {
                    let errorMessages = Object.values(e.data.errors).flat();

                    errorMessages = [...new Set(errorMessages)];

                    message += "\n" + errorMessages.join("\n");

                    this.data.forEach((item, index) => {
                        item.explanation_error =
                            e.data.errors?.[`data.${index}.explanation`]?.join(
                                "\n"
                            ) || null;
                    });
                }

                this.$toast.error(message);
            }
        },
        onIsInProgramChange(item) {
            if (item.status === 'no') {
                item.classroom_type = null;
                item.explanation = null;
                item.explanation_error = null;
            }
        }
    },
};
</script>
